import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as deviceActions } from 'ducks/devices';
import { actions as wiseBoxActions } from 'ducks/wise_boxes';
import { sortBy } from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unixToDate } from 'utils/date';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const Component = props => {
    const { id } = props;
    const { closeDrawer } = props;

    const submitting = useSelector(state => state.devices.submitting);
    const wiseBoxes = useSelector(state => state.wiseBoxes.models);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(wiseBoxActions.fetchAll());
    }, [dispatch]);

    const validWiseBoxes = sortBy(Object.values(wiseBoxes), 'created_at').reverse().reduce((array, wiseBox) => {
        if (wiseBox.status === 'validated') {
            let name = `${wiseBox.id} | last_seen: ${unixToDate(wiseBox.created_at)}`;
            if (wiseBox.activation_code) {
                let code = wiseBox.activation_code.toString(2).padStart(3, 0).padStart(3, 0).split('').join('-');
                name += `  |  activation code: ${code}`;
            }
            array.push({ id: wiseBox.id, name: name });
        }

        return array;
    }, []);

    let formSchema = [
        {
            type: 'select',
            label: 'WiseBox\x2a',
            name: 'wise_box_id',
            validate: [validators.required],
            formData: validWiseBoxes
        }
    ];

    const onSubmit = values => {
        const data = serializeForm(values, formSchema);

        dispatch(deviceActions.reclaim(id, data.wise_box_id, () => {
            closeDrawer();
        }));
    };

    return (
        <FormViewer label="Create Template">
            <Form
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
